import { APAdjustmentRawDto } from './ap-adjustment-raw-dto';

export class ApplyPaymentWithAPCMParameterDto extends APAdjustmentRawDto {
    apPaymentId: number;
}
